<template>
    <div class="mobile-menu" :class="{ open: open }">
        <div class="links">
            <router-link to="/" @click="toggle">
                الرئيسيه
            </router-link>
            <router-link :to="{ name: 'products_all' }" @click="toggle">
                اخر المنتجات
            </router-link>
            <router-link :to="{ name: 'size_instructions' }">
                دليل المقاسات
            </router-link>

            <!-- auth user links -->
            <template v-if="$store.state.isAuthenticated">
                <router-link :to="{ name: 'profile_data' }" class="auth" @click="toggle">
                    <img src="@/assets/profile/cactus.png" alt="">
                    الملف الشخصي
                </router-link>
                <router-link :to="{ name: 'profile_orders' }" class="auth" @click="toggle">
                    <MaClothingStore />
                    اوردراتي
                </router-link>
                <router-link :to="{ name: 'cart' }" class="auth" @click="toggle">
                    <AkCart />
                    عربه التسوق
                </router-link>
                <button class="auth logout" @click="logout">
                    <CiLogout style="margin-left: 0.2rem;" />
                    <span>
                        سجل الخروج
                    </span>
                </button>
            </template>
            <template v-else>
                <router-link :to="{ name: 'register' }" class="auth register" @click="toggle">
                    <BxUserPlus />
                    انشئ حسابك
                </router-link>
                <router-link :to="{ name: 'login' }" class="auth" @click="toggle">
                    <img src="@/assets/header icons/watermelon.png" alt="">
                    <span>
                        سجل دخولك
                    </span>
                </router-link>
            </template>
        </div>
    </div>
</template>
<script>
import { MaClothingStore, CiLogout, BxUserPlus, AkCart } from '@kalimahapps/vue-icons';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
export default {
    name: 'MobileMenuComponent',
    props: ['open', 'toggle'],
    components: {
        MaClothingStore,
        CiLogout,
        BxUserPlus,
        AkCart
    },
    methods: {
        logout() {

            Swal.fire({
                title: "تسجيل الخروج",
                text: "هل انت متاكد من تسجيل الخروج",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "تسجبل خروج",
                cancelButtonText: 'الغاء'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('LOGOUT_USER');
                    Cookies.remove('user_token')
                    this.$router.push('/')
                    this.toggle()
                }
            });

        }
    }
}
</script>
<style scoped>
.mobile-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #BAD8B6;
    z-index: 499;
    transition: all 0.5s ease-in-out;
    transform: translateX(100%);
}

.mobile-menu.open {
    transform: translateX(0);
}

.links {
    margin-top: 115px;
    padding: 1rem 0.3rem;
    display: flex;
    flex-direction: column;
}

.links a {
    all: unset;
    padding: 0.5rem;
    border-radius: 5px;
    margin-bottom: 1rem;
    cursor: pointer;
    display: block;
    width: calc(100% - 1rem);
    /* font-weight: bold; */
    font-size: 1.3rem;
    color: #2c3e50;
    background-color: #E1EACD;
}

.auth {
    all: unset;
    /* padding: 0.5rem 1.2rem; */
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.5s;
    font-weight: bold;
    border: 1px solid #bdc3c7;
}

.auth img {
    width: 2rem;
    height: 2rem;
}

.logout {
    padding: 1rem 0.5rem;
    border: 1.5px solid #727D73;
    justify-content: center;
    color: #727D73;
}

.links a.register {
    background-color: #16C47F;
    color: #fff;
}
</style>